import React from "react";
import "../../styles/NewAuth.css"; // 📌 Upewnij się, że masz odpowiedni styl

const SessionExpiredModal = ({ onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Sesja wygasła</h2>
                <p>Twoja sesja wygasła, zaloguj się ponownie.</p>
                <button onClick={onClose} className="close-btn">OK</button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;